import '../../../../../../../styles/HajoSzallag.css'
import BackButtonPage from '../../../../../../../components/BackButtonPage';


function Hajoszallag() {
    return (
        <>
            <div className='page-content-container asd'>
                <img src="/assets/projekt_kezdetei/hajoszallag/hajotura_szallag.png" className='responsive-img' alt="Hajótúra szallag" />
                <BackButtonPage to="/projekt-kezdetei" />
            </div>
        </> 
    );
}

export default Hajoszallag;